module.exports = __webpack_public_path__ + "Icono_Buscar_Gris_126px.png";